(function () {
  // ===== INTRO SPLASH (video-driven crossfade) =====
  var splash = document.getElementById('intro-splash');
  if (!splash) { document.body.classList.add('intro-done'); }
  if (splash) {
    var isHome = document.body.classList.contains('template-index');
    if (!isHome) {
      splash.classList.add('is-done');
      splash.style.transition = 'none';
      document.body.classList.add('intro-done');
    } else {
      var video = document.getElementById('intro-video');
      var dismissed = false;
      function dismiss() {
        if (dismissed) return;
        dismissed = true;
        document.body.classList.add('intro-done');
        splash.classList.add('is-done');
      }
      if (video) {
        var rate = parseFloat(splash.getAttribute('data-speed')) || 1.2;
        video.playbackRate = rate;
        video.addEventListener('loadedmetadata', function () { video.playbackRate = rate; });
        video.addEventListener('ended', dismiss);
        setTimeout(dismiss, 8000 / rate);
        var p = video.play();
        if (p && p.catch) p.catch(function () { dismiss(); });
      } else {
        setTimeout(dismiss, 1800);
      }
      splash.addEventListener('click', dismiss);
    }
  }

  // ===== LETTER SPLIT =====
  document.querySelectorAll('[data-split-text]').forEach(function (el) {
    var text = el.textContent;
    el.textContent = '';
    var i = 0;
    Array.from(text).forEach(function (ch) {
      var span = document.createElement('span');
      span.className = 'split-char' + (ch === ' ' ? ' split-char--space' : '');
      span.textContent = ch === ' ' ? ' ' : ch;
      span.style.setProperty('--i', i);
      el.appendChild(span);
      i++;
    });
  });

  // ===== SCROLL REVEAL =====
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  // ===== CART COUNT =====
  function refreshCartCount() {
    var el = document.getElementById('cart-count');
    if (!el) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        el.textContent = c.item_count || '';
        el.setAttribute('data-zero', c.item_count ? '0' : '1');
      })
      .catch(function () {});
  }
  refreshCartCount();
  window.YungFazoCart = window.YungFazoCart || {};
  window.YungFazoCart.refreshCount = refreshCartCount;

  document.querySelectorAll('video.hero__bg').forEach(function (v) { v.play().catch(function () {}); });

  // ===== PDP variant logic =====
  var variantsEl = document.getElementById('pdp-variants');
  var form = document.getElementById('pdp-form');
  if (variantsEl && form) {
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    var idInput = document.getElementById('pdp-variant-id');
    var priceEl = document.getElementById('pdp-price');
    var addBtn = document.getElementById('pdp-add');
    function selected() {
      var o = [];
      form.querySelectorAll('input[type=radio]:checked').forEach(function (i) { o.push(i.value); });
      return o;
    }
    function find() {
      var s = selected();
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); });
    }
    function fmt(c) { return '$' + (c / 100).toFixed(c % 100 === 0 ? 0 : 2); }
    function update() {
      var v = find();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    }
    form.addEventListener('change', update);
    update();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); refreshCartCount(); })
        .catch(function () { form.submit(); });
    });
  }

  // ===== CART DRAWER =====
  var drawer = document.getElementById('cart-drawer');
  function openCart() {
    if (!drawer) { window.location = '/cart'; return; }
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    renderCart();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }
  function renderCart() {
    var body = document.getElementById('cart-drawer-body');
    var foot = document.getElementById('cart-drawer-foot');
    var totalEl = document.getElementById('cart-drawer-total');
    if (!body) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          body.innerHTML = '<p class="drawer__empty">cart is empty</p>';
          if (foot) foot.hidden = true;
          return;
        }
        body.innerHTML = cart.items.map(function (i) {
          return '<div class="drawer__item"><img src="' + i.image + '&width=200" alt=""><div class="drawer__item-info"><div class="drawer__item-title">' + i.product_title + '</div><div class="drawer__item-variant">' + (i.variant_title || '') + '</div><div class="drawer__item-row"><button class="drawer__qty" data-key="' + i.key + '" data-delta="-1">−</button><span>' + i.quantity + '</span><button class="drawer__qty" data-key="' + i.key + '" data-delta="1">+</button><span class="drawer__item-price">$' + (i.final_line_price / 100).toFixed(0) + '</span></div></div></div>';
        }).join('');
        if (foot) foot.hidden = false;
        if (totalEl) totalEl.textContent = '$' + (cart.total_price / 100).toFixed(0);
      });
  }
  function changeQty(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) return;
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: item.quantity + delta }) });
    }).then(function () { renderCart(); refreshCartCount(); });
  }
  // ===== SUBSCRIBE POPUP =====
  var popup = document.getElementById('subscribe-popup');
  function openPopup() {
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('popup-open');
    var input = popup.querySelector('.popup__input');
    setTimeout(function () { input && input.focus(); }, 320);
  }
  function closePopup() {
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-open');
  }

  document.addEventListener('click', function (e) {
    var cartTrigger = e.target.closest('.site-header__cart');
    if (cartTrigger) { e.preventDefault(); openCart(); return; }
    var popupOpen = e.target.closest('[data-popup-open="subscribe"]');
    if (popupOpen) { e.preventDefault(); openPopup(); return; }
    if (e.target.matches('[data-popup-close]') || e.target.closest('[data-popup-close]')) closePopup();
    if (e.target.matches('[data-drawer-close]')) closeCart();
    if (e.target.matches('.drawer__qty')) changeQty(e.target.dataset.key, parseInt(e.target.dataset.delta, 10));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closePopup(); } });

  // ===== iPod PLAYER =====
  var ipodTracksEl = document.getElementById('ipod-tracks');
  if (ipodTracksEl) {
    var ipodTracks = [];
    try { ipodTracks = JSON.parse(ipodTracksEl.textContent); } catch (e) {}
    var ipodAudio = document.getElementById('ipod-audio');
    var ipodTitle = document.getElementById('ipod-title');
    var ipodArtist = document.getElementById('ipod-artist');
    var ipodCounter = document.getElementById('ipod-counter');
    var ipodPlay = document.getElementById('ipod-play');
    var ipodProgress = document.getElementById('ipod-progress');
    var ipodIdx = 0;
    var ipodLoaded = false;

    function ipodLoad(i) {
      if (!ipodTracks.length) return;
      ipodIdx = ((i % ipodTracks.length) + ipodTracks.length) % ipodTracks.length;
      var t = ipodTracks[ipodIdx];
      ipodAudio.src = t.url || '';
      ipodTitle.textContent = (t.title || 'UNTITLED').toUpperCase();
      ipodArtist.textContent = (t.artist || '').toUpperCase();
      ipodCounter.textContent = (ipodIdx + 1) + ' of ' + ipodTracks.length;
      ipodLoaded = true;
    }
    function ipodPlayPause() {
      if (!ipodTracks.length) return;
      if (!ipodLoaded) ipodLoad(0);
      if (ipodAudio.paused) { ipodAudio.play().catch(function(){}); }
      else { ipodAudio.pause(); }
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ipod]');
      if (!b) return;
      var act = b.dataset.ipod;
      if (act === 'play') ipodPlayPause();
      else if (act === 'next') { ipodLoad(ipodIdx + 1); ipodAudio.play().catch(function(){}); }
      else if (act === 'prev') { ipodLoad(ipodIdx - 1); ipodAudio.play().catch(function(){}); }
      else if (act === 'menu') { ipodAudio.pause(); ipodAudio.currentTime = 0; ipodProgress.style.width = '0%'; }
    });
    ipodAudio.addEventListener('timeupdate', function () {
      if (ipodAudio.duration) ipodProgress.style.width = (ipodAudio.currentTime / ipodAudio.duration * 100) + '%';
    });
    ipodAudio.addEventListener('ended', function () {
      ipodLoad(ipodIdx + 1);
      ipodAudio.play().catch(function(){});
    });
    ipodAudio.addEventListener('play',  function () { ipodPlay.textContent = '⏸'; });
    ipodAudio.addEventListener('pause', function () { ipodPlay.textContent = '▶'; });

    // Pre-load first track metadata only — song starts on user click.
    if (ipodTracks.length) ipodLoad(0);
  }
  window.YungFazoCart.open = openCart;
  window.YungFazoCart.close = closeCart;
  // ===== PASSWORD PAGE COUNTDOWN =====
  var cd = document.querySelector('.passhero__countdown');
  if (cd && cd.dataset.release) {
    var target = new Date(cd.dataset.release).getTime();
    var slots = {
      d: cd.querySelector('[data-cd="d"]'),
      h: cd.querySelector('[data-cd="h"]'),
      m: cd.querySelector('[data-cd="m"]'),
      s: cd.querySelector('[data-cd="s"]')
    };
    function pad(n){ return String(n).padStart(2,'0'); }
    function tickCd(){
      var diff = Math.max(0, target - Date.now());
      var s = Math.floor(diff/1000);
      if (slots.d) slots.d.textContent = pad(Math.floor(s/86400));
      if (slots.h) slots.h.textContent = pad(Math.floor(s%86400/3600));
      if (slots.m) slots.m.textContent = pad(Math.floor(s%3600/60));
      if (slots.s) slots.s.textContent = pad(s%60);
    }
    tickCd(); setInterval(tickCd, 1000);
  }



  // ===== WHITE AURA CURSOR TRAIL =====
  if (matchMedia('(pointer:fine)').matches) {
    var AURA_N = 16;
    var auraDots = [];
    var auraX = window.innerWidth / 2, auraY = window.innerHeight / 2;
    for (var ai = 0; ai < AURA_N; ai++) {
      var d = document.createElement('span');
      d.className = 'aura-dot';
      var t = ai / (AURA_N - 1);            // 0 = head, 1 = tail
      var size = 34 - t * 22;               // 34px head -> 12px tail
      var alpha = 0.30 - t * 0.26;          // fades toward tail
      var blur  = 8 + t * 16;
      var shade = 255 - Math.round(t * 90); // white -> soft silver
      d.style.width  = size + 'px';
      d.style.height = size + 'px';
      d.style.filter = 'blur(' + blur + 'px)';
      d.style.background =
        'radial-gradient(circle at 50% 50%, rgba(255,255,255,' + (alpha + 0.18).toFixed(3) + ') 0%, ' +
        'rgba(' + shade + ',' + shade + ',' + shade + ',' + alpha.toFixed(3) + ') 45%, ' +
        'rgba(255,255,255,0) 72%)';
      document.body.appendChild(d);
      auraDots.push({ el: d, x: auraX, y: auraY });
    }
    document.addEventListener('mousemove', function (e) {
      auraX = e.clientX; auraY = e.clientY;
    }, { passive: true });
    (function auraLoop() {
      var px = auraX, py = auraY;
      for (var i = 0; i < auraDots.length; i++) {
        var dot = auraDots[i];
        dot.x += (px - dot.x) * 0.35;
        dot.y += (py - dot.y) * 0.35;
        dot.el.style.transform = 'translate(' + dot.x + 'px,' + dot.y + 'px) translate(-50%,-50%)';
        px = dot.x; py = dot.y;
      }
      requestAnimationFrame(auraLoop);
    })();
  }

})();

